import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import CommonIcon from "../../helpers/icons";
import { KeyboardArrowRight, KeyboardArrowDown } from "@mui/icons-material";
import toggleMenu from "../../../redux/SideBar/sideBarActions";
import sideMenu from "../../../redux/SideBar/sideMenuAction";
import Button from "react-bootstrap/Button";
import { Loader } from "../../custom/CommonFunction";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { LastLogin } from "../../../action/UsersApi";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const StatusTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#A8A8A8",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#A8A8A8",
    color: theme.palette.common.white,
    borderRadius: 0,
  },
}));
const SideBar = (props) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const path = window.location.pathname;

  const [sideMenu, setSideMenu] = useState(false);
  const [isSidebar, setIsSidebar] = useState(true);
  const [isMobile, setisMobile] = useState(false);
  const [isMobile1, setisMobile1] = useState(false);
  const [webMobile, setiswebMobile] = useState(false);
  const [windowHeight, setwindowHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const [userData, setUserData] = useState({});
  const [isSettings, setIsSettings] = useState(false);
  const [opendialog, setOpendialog] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [username, setUsername] = useState();

  const routeNavigation = (path) => {
    navigate(path);
  };
  useEffect(() => {
    resize();
    function handleResize() {
      resize();
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // useEffect(() => {
  //   if (
  //     localStorage.getItem("UserInfoTAC") !== "" &&
  //     localStorage.getItem("UserInfoTAC") !== null &&
  //     localStorage.getItem("UserInfoTAC") !== undefined
  //   ) {
  //     let currentUser = {
  //       name: JSON.parse(localStorage.getItem("UserInfoTAC"))?.name,
  //       jobTitle:
  //         JSON.parse(localStorage.getItem("UserInfoTAC"))?.userRole ||
  //         "Software Engineer",
  //     };
  //     setUserData(currentUser);
  //   }
  // }, [userData]);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     if (
  //       localStorage.getItem("UserInfoTAC") !== "" &&
  //       localStorage.getItem("UserInfoTAC") !== null &&
  //       localStorage.getItem("UserInfoTAC") !== undefined
  //     ) {
  //       let currentUser = {
  //         name: JSON.parse(localStorage.getItem("UserInfoTAC"))?.name,
  //         jobTitle:
  //           JSON.parse(localStorage.getItem("UserInfoTAC"))?.userRole ||
  //           "Software Engineer",
  //       };
  //       setUserData(currentUser);
  //     }
  //   }, 5000);

  //   return () => clearInterval(intervalId);
  // }, []);

  useEffect(() => {
    const updateUserData = () => {
      if (
        localStorage.getItem("UserInfoTAC") !== "" &&
        localStorage.getItem("UserInfoTAC") !== null &&
        localStorage.getItem("UserInfoTAC") !== undefined
      ) {
        let currentUser = {
          name: JSON.parse(localStorage.getItem("UserInfoTAC"))?.name,
          jobTitle:
            JSON.parse(localStorage.getItem("UserInfoTAC"))?.userRole ||
            "Software Engineer",
        };
        setUserData(currentUser);
      }
    };
    updateUserData();
    const intervalId = setInterval(updateUserData, 5000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (path !== "/users" && path !== "/applications") {
      setIsSettings(true);
    } else {
      setIsSettings(false);
    }
  }, [path]);

  const resize = () => {
    setwindowHeight(window.innerHeight);
    if (window.innerWidth < 470) {
      setisMobile(true);
      setiswebMobile(true);
    } else {
      setiswebMobile(false);
      setisMobile(false);
    }
    if (window.innerWidth < 388) {
      setisMobile1(true);
    } else {
      setisMobile1(false);
    }
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    console.log(
      transformCountries([
        { code: "AD", label: "Andorra", phone: "376" },
        {
          code: "AE",
          label: "United Arab Emirates",
          phone: "971",
        },
        { code: "AF", label: "Afghanistan", phone: "93" },
        {
          code: "AG",
          label: "Antigua and Barbuda",
          phone: "1-268",
        },
        { code: "AI", label: "Anguilla", phone: "1-264" },
        { code: "AL", label: "Albania", phone: "355" },
        { code: "AM", label: "Armenia", phone: "374" },
        { code: "AO", label: "Angola", phone: "244" },
        { code: "AQ", label: "Antarctica", phone: "672" },
        { code: "AR", label: "Argentina", phone: "54" },
        { code: "AS", label: "American Samoa", phone: "1-684" },
        { code: "AT", label: "Austria", phone: "43" },
        {
          code: "AU",
          label: "Australia",
          phone: "61",
          suggested: true,
        },
        { code: "AW", label: "Aruba", phone: "297" },
        { code: "AX", label: "Alland Islands", phone: "358" },
        { code: "AZ", label: "Azerbaijan", phone: "994" },
        {
          code: "BA",
          label: "Bosnia and Herzegovina",
          phone: "387",
        },
        { code: "BB", label: "Barbados", phone: "1-246" },
        { code: "BD", label: "Bangladesh", phone: "880" },
        { code: "BE", label: "Belgium", phone: "32" },
        { code: "BF", label: "Burkina Faso", phone: "226" },
        { code: "BG", label: "Bulgaria", phone: "359" },
        { code: "BH", label: "Bahrain", phone: "973" },
        { code: "BI", label: "Burundi", phone: "257" },
        { code: "BJ", label: "Benin", phone: "229" },
        { code: "BL", label: "Saint Barthelemy", phone: "590" },
        { code: "BM", label: "Bermuda", phone: "1-441" },
        { code: "BN", label: "Brunei Darussalam", phone: "673" },
        { code: "BO", label: "Bolivia", phone: "591" },
        { code: "BR", label: "Brazil", phone: "55" },
        { code: "BS", label: "Bahamas", phone: "1-242" },
        { code: "BT", label: "Bhutan", phone: "975" },
        { code: "BV", label: "Bouvet Island", phone: "47" },
        { code: "BW", label: "Botswana", phone: "267" },
        { code: "BY", label: "Belarus", phone: "375" },
        { code: "BZ", label: "Belize", phone: "501" },
        {
          code: "CA",
          label: "Canada",
          phone: "1",
          suggested: true,
        },
        {
          code: "CC",
          label: "Cocos (Keeling) Islands",
          phone: "61",
        },
        {
          code: "CD",
          label: "Congo, Democratic Republic of the",
          phone: "243",
        },
        {
          code: "CF",
          label: "Central African Republic",
          phone: "236",
        },
        {
          code: "CG",
          label: "Congo, Republic of the",
          phone: "242",
        },
        { code: "CH", label: "Switzerland", phone: "41" },
        { code: "CI", label: "Cote d'Ivoire", phone: "225" },
        { code: "CK", label: "Cook Islands", phone: "682" },
        { code: "CL", label: "Chile", phone: "56" },
        { code: "CM", label: "Cameroon", phone: "237" },
        { code: "CN", label: "China", phone: "86" },
        { code: "CO", label: "Colombia", phone: "57" },
        { code: "CR", label: "Costa Rica", phone: "506" },
        { code: "CU", label: "Cuba", phone: "53" },
        { code: "CV", label: "Cape Verde", phone: "238" },
        { code: "CW", label: "Curacao", phone: "599" },
        { code: "CX", label: "Christmas Island", phone: "61" },
        { code: "CY", label: "Cyprus", phone: "357" },
        { code: "CZ", label: "Czech Republic", phone: "420" },
        {
          code: "DE",
          label: "Germany",
          phone: "49",
          suggested: true,
        },
        { code: "DJ", label: "Djibouti", phone: "253" },
        { code: "DK", label: "Denmark", phone: "45" },
        { code: "DM", label: "Dominica", phone: "1-767" },
        {
          code: "DO",
          label: "Dominican Republic",
          phone: "1-809",
        },
        { code: "DZ", label: "Algeria", phone: "213" },
        { code: "EC", label: "Ecuador", phone: "593" },
        { code: "EE", label: "Estonia", phone: "372" },
        { code: "EG", label: "Egypt", phone: "20" },
        { code: "EH", label: "Western Sahara", phone: "212" },
        { code: "ER", label: "Eritrea", phone: "291" },
        { code: "ES", label: "Spain", phone: "34" },
        { code: "ET", label: "Ethiopia", phone: "251" },
        { code: "FI", label: "Finland", phone: "358" },
        { code: "FJ", label: "Fiji", phone: "679" },
        {
          code: "FK",
          label: "Falkland Islands (Malvinas)",
          phone: "500",
        },
        {
          code: "FM",
          label: "Micronesia, Federated States of",
          phone: "691",
        },
        { code: "FO", label: "Faroe Islands", phone: "298" },
        {
          code: "FR",
          label: "France",
          phone: "33",
          suggested: true,
        },
        { code: "GA", label: "Gabon", phone: "241" },
        { code: "GB", label: "United Kingdom", phone: "44" },
        { code: "GD", label: "Grenada", phone: "1-473" },
        { code: "GE", label: "Georgia", phone: "995" },
        { code: "GF", label: "French Guiana", phone: "594" },
        { code: "GG", label: "Guernsey", phone: "44" },
        { code: "GH", label: "Ghana", phone: "233" },
        { code: "GI", label: "Gibraltar", phone: "350" },
        { code: "GL", label: "Greenland", phone: "299" },
        { code: "GM", label: "Gambia", phone: "220" },
        { code: "GN", label: "Guinea", phone: "224" },
        { code: "GP", label: "Guadeloupe", phone: "590" },
        { code: "GQ", label: "Equatorial Guinea", phone: "240" },
        { code: "GR", label: "Greece", phone: "30" },
        {
          code: "GS",
          label: "South Georgia and the South Sandwich Islands",
          phone: "500",
        },
        { code: "GT", label: "Guatemala", phone: "502" },
        { code: "GU", label: "Guam", phone: "1-671" },
        { code: "GW", label: "Guinea-Bissau", phone: "245" },
        { code: "GY", label: "Guyana", phone: "592" },
        { code: "HK", label: "Hong Kong", phone: "852" },
        {
          code: "HM",
          label: "Heard Island and McDonald Islands",
          phone: "672",
        },
        { code: "HN", label: "Honduras", phone: "504" },
        { code: "HR", label: "Croatia", phone: "385" },
        { code: "HT", label: "Haiti", phone: "509" },
        { code: "HU", label: "Hungary", phone: "36" },
        { code: "ID", label: "Indonesia", phone: "62" },
        { code: "IE", label: "Ireland", phone: "353" },
        { code: "IL", label: "Israel", phone: "972" },
        { code: "IM", label: "Isle of Man", phone: "44" },
        { code: "IN", label: "India", phone: "91" },
        {
          code: "IO",
          label: "British Indian Ocean Territory",
          phone: "246",
        },
        { code: "IQ", label: "Iraq", phone: "964" },
        {
          code: "IR",
          label: "Iran, Islamic Republic of",
          phone: "98",
        },
        { code: "IS", label: "Iceland", phone: "354" },
        { code: "IT", label: "Italy", phone: "39" },
        { code: "JE", label: "Jersey", phone: "44" },
        { code: "JM", label: "Jamaica", phone: "1-876" },
        { code: "JO", label: "Jordan", phone: "962" },
        {
          code: "JP",
          label: "Japan",
          phone: "81",
          suggested: true,
        },
        { code: "KE", label: "Kenya", phone: "254" },
        { code: "KG", label: "Kyrgyzstan", phone: "996" },
        { code: "KH", label: "Cambodia", phone: "855" },
        { code: "KI", label: "Kiribati", phone: "686" },
        { code: "KM", label: "Comoros", phone: "269" },
        {
          code: "KN",
          label: "Saint Kitts and Nevis",
          phone: "1-869",
        },
        {
          code: "KP",
          label: "Korea, Democratic People's Republic of",
          phone: "850",
        },
        { code: "KR", label: "Korea, Republic of", phone: "82" },
        { code: "KW", label: "Kuwait", phone: "965" },
        { code: "KY", label: "Cayman Islands", phone: "1-345" },
        { code: "KZ", label: "Kazakhstan", phone: "7" },
        {
          code: "LA",
          label: "Lao People's Democratic Republic",
          phone: "856",
        },
        { code: "LB", label: "Lebanon", phone: "961" },
        { code: "LC", label: "Saint Lucia", phone: "1-758" },
        { code: "LI", label: "Liechtenstein", phone: "423" },
        { code: "LK", label: "Sri Lanka", phone: "94" },
        { code: "LR", label: "Liberia", phone: "231" },
        { code: "LS", label: "Lesotho", phone: "266" },
        { code: "LT", label: "Lithuania", phone: "370" },
        { code: "LU", label: "Luxembourg", phone: "352" },
        { code: "LV", label: "Latvia", phone: "371" },
        { code: "LY", label: "Libya", phone: "218" },
        { code: "MA", label: "Morocco", phone: "212" },
        { code: "MC", label: "Monaco", phone: "377" },
        {
          code: "MD",
          label: "Moldova, Republic of",
          phone: "373",
        },
        { code: "ME", label: "Montenegro", phone: "382" },
        {
          code: "MF",
          label: "Saint Martin (French part)",
          phone: "590",
        },
        { code: "MG", label: "Madagascar", phone: "261" },
        { code: "MH", label: "Marshall Islands", phone: "692" },
        {
          code: "MK",
          label: "Macedonia, the Former Yugoslav Republic of",
          phone: "389",
        },
        { code: "ML", label: "Mali", phone: "223" },
        { code: "MM", label: "Myanmar", phone: "95" },
        { code: "MN", label: "Mongolia", phone: "976" },
        { code: "MO", label: "Macao", phone: "853" },
        {
          code: "MP",
          label: "Northern Mariana Islands",
          phone: "1-670",
        },
        { code: "MQ", label: "Martinique", phone: "596" },
        { code: "MR", label: "Mauritania", phone: "222" },
        { code: "MS", label: "Montserrat", phone: "1-664" },
        { code: "MT", label: "Malta", phone: "356" },
        { code: "MU", label: "Mauritius", phone: "230" },
        { code: "MV", label: "Maldives", phone: "960" },
        { code: "MW", label: "Malawi", phone: "265" },
        { code: "MX", label: "Mexico", phone: "52" },
        { code: "MY", label: "Malaysia", phone: "60" },
        { code: "MZ", label: "Mozambique", phone: "258" },
        { code: "NA", label: "Namibia", phone: "264" },
        { code: "NC", label: "New Caledonia", phone: "687" },
        { code: "NE", label: "Niger", phone: "227" },
        { code: "NF", label: "Norfolk Island", phone: "672" },
        { code: "NG", label: "Nigeria", phone: "234" },
        { code: "NI", label: "Nicaragua", phone: "505" },
        { code: "NL", label: "Netherlands", phone: "31" },
        { code: "NO", label: "Norway", phone: "47" },
        { code: "NP", label: "Nepal", phone: "977" },
        { code: "NR", label: "Nauru", phone: "674" },
        { code: "NU", label: "Niue", phone: "683" },
        { code: "NZ", label: "New Zealand", phone: "64" },
        { code: "OM", label: "Oman", phone: "968" },
        { code: "PA", label: "Panama", phone: "507" },
        { code: "PE", label: "Peru", phone: "51" },
        { code: "PF", label: "French Polynesia", phone: "689" },
        { code: "PG", label: "Papua New Guinea", phone: "675" },
        { code: "PH", label: "Philippines", phone: "63" },
        { code: "PK", label: "Pakistan", phone: "92" },
        { code: "PL", label: "Poland", phone: "48" },
        {
          code: "PM",
          label: "Saint Pierre and Miquelon",
          phone: "508",
        },
        { code: "PN", label: "Pitcairn", phone: "870" },
        { code: "PR", label: "Puerto Rico", phone: "1" },
        {
          code: "PS",
          label: "Palestine, State of",
          phone: "970",
        },
        { code: "PT", label: "Portugal", phone: "351" },
        { code: "PW", label: "Palau", phone: "680" },
        { code: "PY", label: "Paraguay", phone: "595" },
        { code: "QA", label: "Qatar", phone: "974" },
        { code: "RE", label: "Reunion", phone: "262" },
        { code: "RO", label: "Romania", phone: "40" },
        { code: "RS", label: "Serbia", phone: "381" },
        { code: "RU", label: "Russian Federation", phone: "7" },
        { code: "RW", label: "Rwanda", phone: "250" },
        { code: "SA", label: "Saudi Arabia", phone: "966" },
        { code: "SB", label: "Solomon Islands", phone: "677" },
        { code: "SC", label: "Seychelles", phone: "248" },
        { code: "SD", label: "Sudan", phone: "249" },
        { code: "SE", label: "Sweden", phone: "46" },
        { code: "SG", label: "Singapore", phone: "65" },
        { code: "SH", label: "Saint Helena", phone: "290" },
        { code: "SI", label: "Slovenia", phone: "386" },
        {
          code: "SJ",
          label: "Svalbard and Jan Mayen",
          phone: "47",
        },
        { code: "SK", label: "Slovakia", phone: "421" },
        { code: "SL", label: "Sierra Leone", phone: "232" },
        { code: "SM", label: "San Marino", phone: "378" },
        { code: "SN", label: "Senegal", phone: "221" },
        { code: "SO", label: "Somalia", phone: "252" },
        { code: "SR", label: "Suriname", phone: "597" },
        { code: "SS", label: "South Sudan", phone: "211" },
        {
          code: "ST",
          label: "Sao Tome and Principe",
          phone: "239",
        },
        { code: "SV", label: "El Salvador", phone: "503" },
        {
          code: "SX",
          label: "Sint Maarten (Dutch part)",
          phone: "1-721",
        },
        {
          code: "SY",
          label: "Syrian Arab Republic",
          phone: "963",
        },
        { code: "SZ", label: "Swaziland", phone: "268" },
        {
          code: "TC",
          label: "Turks and Caicos Islands",
          phone: "1-649",
        },
        { code: "TD", label: "Chad", phone: "235" },
        {
          code: "TF",
          label: "French Southern Territories",
          phone: "262",
        },
        { code: "TG", label: "Togo", phone: "228" },
        { code: "TH", label: "Thailand", phone: "66" },
        { code: "TJ", label: "Tajikistan", phone: "992" },
        { code: "TK", label: "Tokelau", phone: "690" },
        { code: "TL", label: "Timor-Leste", phone: "670" },
        { code: "TM", label: "Turkmenistan", phone: "993" },
        { code: "TN", label: "Tunisia", phone: "216" },
        { code: "TO", label: "Tonga", phone: "676" },
        { code: "TR", label: "Turkey", phone: "90" },
        {
          code: "TT",
          label: "Trinidad and Tobago",
          phone: "1-868",
        },
        { code: "TV", label: "Tuvalu", phone: "688" },
        {
          code: "TW",
          label: "Taiwan",
          phone: "886",
        },
        {
          code: "TZ",
          label: "United Republic of Tanzania",
          phone: "255",
        },
        { code: "UA", label: "Ukraine", phone: "380" },
        { code: "UG", label: "Uganda", phone: "256" },
        {
          code: "US",
          label: "United States",
          phone: "1",
          suggested: true,
        },
        { code: "UY", label: "Uruguay", phone: "598" },
        { code: "UZ", label: "Uzbekistan", phone: "998" },
        {
          code: "VA",
          label: "Holy See (Vatican City State)",
          phone: "379",
        },
        {
          code: "VC",
          label: "Saint Vincent and the Grenadines",
          phone: "1-784",
        },
        { code: "VE", label: "Venezuela", phone: "58" },
        {
          code: "VG",
          label: "British Virgin Islands",
          phone: "1-284",
        },
        {
          code: "VI",
          label: "US Virgin Islands",
          phone: "1-340",
        },
        { code: "VN", label: "Vietnam", phone: "84" },
        { code: "VU", label: "Vanuatu", phone: "678" },
        { code: "WF", label: "Wallis and Futuna", phone: "681" },
        { code: "WS", label: "Samoa", phone: "685" },
        { code: "XK", label: "Kosovo", phone: "383" },
        { code: "YE", label: "Yemen", phone: "967" },
        { code: "YT", label: "Mayotte", phone: "262" },
        { code: "ZA", label: "South Africa", phone: "27" },
        { code: "ZM", label: "Zambia", phone: "260" },
        { code: "ZW", label: "Zimbabwe", phone: "263" },
      ])
    );
  }, []);

  function transformCountries(countries) {
    return countries.map((item, index) => ({
      id: index + 1,
      countryName: item.label,
      countryCode: `+${item.phone.replace(/-/g, "")}`,
      code: item.code,
    }));
  }

  const MinimizeFunc = () => {
    console.log("sideMenu: ", sideMenu, webMobile);
    if (!sideMenu) {
      setSideMenu(true);
      props.sideMenu();
    } else {
      setSideMenu(false);
      props.sideMenu();
    }
  };

  const ClickMenu = () => {
    if (!isSidebar) {
      setIsSidebar(true);
      dispatch({ type: "SIDE_MENU_MOB", data: isSidebar });
      props.toggleMenu();
    } else {
      setIsSidebar(false);
      dispatch({ type: "SIDE_MENU_MOB", data: isSidebar });
      props.toggleMenu();
    }
  };

  const noAction = () => {
    setOpendialog(false);
  };

  const yesAction = () => {
    props.dispatch({ type: "IS_LOGIN", data: false });
    setOpendialog(false);
    // dispatch(Loader(true));
    props.handleLogout();
  };

  const open = Boolean(anchorEl);
  const id = open
    ? sideMenu
      ? "simple_sidemenu-popover"
      : "simple-popover"
    : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    console.log(event.currentTarget);
  };

  const handleClose = () => {
    //
    console.log("null");
    setAnchorEl(null);
  };

  const handleOpenDialog = () => {
    setOpendialog(true);
  };
  const isSSOTAC = JSON.parse(localStorage.getItem("isSSOConfigTAC"));

  return (
    <>
      <Popover
        //  anchorReference="anchorPosition"
        //  anchorPosition={{ top: -10, left: -40 }}
        id={id}
        open={open}
        arrow={true}
        flip={true}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Typography sx={{ p: 2 }} id="logout_popup">
          <span
            className="addlink fw-400 cursor-pointer"
            onClick={() => {
              handleClose();
              handleOpenDialog();
            }}
          >
            Log Out
          </span>
        </Typography>
      </Popover>
      <>
        {isMobile === false && (
          <div
            className={`side-barHeight ${
              webMobile
                ? "side-bar-hide"
                : sideMenu
                ? "side-bar-min"
                : "side-bar"
            }`}
          >
            <div className="row d-flex justify-content-center">
              <div
                className={`titleLogo pr-0 ${sideMenu ? "col-12" : "col-12"}`}
              >
                <span className={sideMenu ? "ps-2" : ""}>
                  {sideMenu ? (
                    <CommonIcon fileName={"flaz_logo_small"} />
                  ) : (
                    <CommonIcon fileName={"flaz_logo"} />
                  )}{" "}
                </span>
                {/* <StatusTooltip title={sideMenu ? 'Expand' : 'Collapse'} placement="right"> */}
                <span
                  onClick={MinimizeFunc}
                  className="float-end close-cursor arrowCursor"
                >
                  {sideMenu ? (
                    <CommonIcon fileName={"RightArrowcollapse"} />
                  ) : (
                    <CommonIcon fileName={"LeftArrowcollapse"} />
                  )}
                </span>
              </div>
            </div>
            <div
              className={`cursor-pointer ${
                sideMenu ? "profile_det_mob" : "profile_det"
              } `}
              aria-describedby={id}
              variant="contained"
              onClick={handleClick}
            >
              <div
                className={`${sideMenu ? "profile-logo-mob" : "profile-logo"} `}
              >
                {/* {console.log(userData.name)} */}
                <span
                  className={`${
                    sideMenu ? "profile-name-short-mob" : "profile-name-short"
                  } `}
                >
                  {userData?.name ? (
                    `${userData.name.charAt(0)}${userData.name
                      .split(" ")
                      .slice(-1)[0]
                      .charAt(0)
                      .toUpperCase()}`
                  ) : localStorage.getItem("firstnameTAC") &&
                    localStorage.getItem("lastnameTAC") ? (
                    localStorage
                      .getItem("firstnameTAC")
                      ?.charAt(0)
                      .toUpperCase() +
                    localStorage.getItem("lastnameTAC")?.charAt(0).toUpperCase()
                  ) : (
                    <CommonIcon fileName={"PersonActive"} />
                  )}
                </span>
              </div>
              {sideMenu === false && (
                <div className="profile-info">
                  <p className="profile-name">
                    {userData?.name
                      ? userData?.name
                      : localStorage.getItem("firstnameTAC") &&
                        localStorage.getItem("lastnameTAC")
                      ? localStorage.getItem("firstnameTAC") +
                        localStorage.getItem("lastnameTAC")
                      : localStorage.getItem("userNameTAC")}
                  </p>
                  <p className="profile-designation">{userData?.jobTitle}</p>
                </div>
              )}
            </div>
            {!props.BG_LOADER &&
            !path.includes("/unauthorize") &&
            JSON.parse(localStorage.getItem("UserInfoTAC"))?.userRole ==
              "Admin" ? (
              <>
                <div className={`menu-list menu-overflow`}>
                  {!isSSOTAC && (
                    <>
                      <div
                        title={sideMenu ? "Users" : ""}
                        className={`${
                          sideMenu === true ? "pt-p8 pb-p8" : " "
                        }  ${
                          path.includes("/users")
                            ? sideMenu === true
                              ? "sidebar-active-mob"
                              : " sidebar-active pl-20"
                            : sideMenu === true
                            ? "sidebar-mob"
                            : "pl-20 sidebar"
                        } d-flex cursor-pointer`}
                        onClick={() => routeNavigation("/users")}
                      >
                        {path.includes("/users") ? (
                          <CommonIcon fileName={"PersonActive"} />
                        ) : (
                          <CommonIcon fileName={"Person"} />
                        )}
                        {sideMenu === false && (
                          <div
                            className={`${
                              path.includes("/users") ? "fw-bold" : ""
                            }
                          pl-24 pr-20 text-overflow app-label`}
                          >
                            Users
                          </div>
                        )}
                      </div>
                      {/* <div
                    title={sideMenu ? "Groups" : ""}
                    className={`${sideMenu === true ? "pt-p8 pb-p8" : " "}  ${
                      path.includes("/groups")
                        ? sideMenu === true
                          ? "sidebar-active-mob"
                          : " sidebar-active pl-20"
                        : sideMenu === true
                        ? "sidebar-mob"
                        : "pl-20 sidebar"
                    } d-flex cursor-pointer`}
                    onClick={() => routeNavigation("/groups")}
                  >
                    {path.includes("/groups") ? (
                      <CommonIcon fileName={"Groups"} />
                    ) : (
                      <CommonIcon fileName={"Groups"} />
                    )}
                    {sideMenu === false && (
                      <div
                        className={`${path.includes("/groups") ? "fw-bold" : ""}
                          pl-24 pr-20 text-overflow app-label`}
                      >
                        Groups
                      </div>
                    )}
                  </div> */}
                      <div
                        title={sideMenu ? "Teams" : ""}
                        className={`${
                          sideMenu === true ? "pt-p8 pb-p8" : " "
                        }  ${
                          path.includes("/teams")
                            ? sideMenu === true
                              ? "sidebar-active-mob"
                              : " sidebar-active pl-20"
                            : sideMenu === true
                            ? "sidebar-mob"
                            : "pl-20 sidebar"
                        } d-flex cursor-pointer`}
                        onClick={() => routeNavigation("/teams")}
                      >
                        {path.includes("/teams") ? (
                          <CommonIcon fileName={"teamsActive"} />
                        ) : (
                          <CommonIcon fileName={"teams"} />
                        )}
                        {sideMenu === false && (
                          <div
                            className={`${
                              path.includes("/teams") ? "fw-bold" : ""
                            }
                          pl-24 pr-20 text-overflow app-label`}
                          >
                            Teams
                          </div>
                        )}
                      </div>
                    </>
                  )}
                  <div
                    title={sideMenu ? "Products" : ""}
                    className={`${sideMenu === true ? "pt-p8 pb-p8" : " "}  ${
                      path.includes("/applications")
                        ? sideMenu === true
                          ? "sidebar-active-mob"
                          : " sidebar-active pl-20"
                        : sideMenu === true
                        ? "sidebar-mob"
                        : "pl-20 sidebar"
                    } d-flex cursor-pointer`}
                    onClick={() => routeNavigation("/applications")}
                  >
                    {path.includes("/applications") ? (
                      <CommonIcon fileName={"JobApplicationSideLogoActive"} />
                    ) : (
                      <CommonIcon fileName={"JobApplicationSideLogo"} />
                    )}
                    {sideMenu === false && (
                      <div
                        className={`${
                          path.includes("/applications") ? "fw-bold" : ""
                        }
                          pl-24 pr-20 text-overflow app-label`}
                      >
                        Products
                      </div>
                    )}
                  </div>
                  <div
                    title={sideMenu ? "Subscriptions" : ""}
                    className={`${sideMenu === true ? "pt-p8 pb-p8" : " "}  ${
                      path.includes("/subscription")
                        ? sideMenu === true
                          ? "sidebar-active-mob"
                          : " sidebar-active pl-20"
                        : sideMenu === true
                        ? "sidebar-mob"
                        : "pl-20 sidebar"
                    } d-flex cursor-pointer`}
                    onClick={() => routeNavigation("/subscription")}
                  >
                    {path.includes("/subscription") ? (
                      <CommonIcon fileName={"subscription"} />
                    ) : (
                      <CommonIcon fileName={"subscription"} />
                    )}
                    {sideMenu === false && (
                      <div
                        className={`${
                          path.includes("/subscription") ? "fw-bold" : ""
                        }
                          pl-24 pr-20 text-overflow app-label`}
                      >
                        Subscriptions
                      </div>
                    )}
                  </div>
                  <div
                    title={sideMenu ? "Bills and payments" : ""}
                    className={`${sideMenu === true ? "pt-p8 pb-p8" : " "}  ${
                      path.includes("/billpayments")
                        ? sideMenu === true
                          ? "sidebar-active-mob"
                          : " sidebar-active pl-20"
                        : sideMenu === true
                        ? "sidebar-mob"
                        : "pl-20 sidebar"
                    } d-flex cursor-pointer`}
                    onClick={() => routeNavigation("/billpayments")}
                  >
                    {path.includes("/billpayments") ? (
                      <CommonIcon fileName={"bill"} />
                    ) : (
                      <CommonIcon fileName={"billnotselect"} />
                    )}
                    {sideMenu === false && (
                      <div
                        className={`${
                          path.includes("/billpayments") ? "fw-bold" : ""
                        }
                          pl-24 pr-20 text-overflow app-label`}
                      >
                        Bills and Payments
                      </div>
                    )}
                  </div>

                  <div
                    title={sideMenu ? "Settings" : ""}
                    className={`${sideMenu === true ? "pt-p8 pb-p8" : " "}  ${
                      path.includes("/settings")
                        ? sideMenu === true
                          ? "sidebar-active-mob"
                          : " sidebar-active pl-20"
                        : sideMenu === true
                        ? "sidebar-mob"
                        : "pl-20 sidebar"
                    } d-flex cursor-pointer`}
                    onClick={() => routeNavigation("/settings")}
                  >
                    {path.includes("/settings") ? (
                      <CommonIcon fileName={"Settings"} />
                    ) : (
                      <CommonIcon fileName={"Settings"} />
                    )}
                    {sideMenu === false && (
                      <div
                        className={`${
                          path.includes("/settings") ? "fw-bold" : ""
                        }
                          pl-24 pr-20 text-overflow app-label`}
                      >
                        Settings
                      </div>
                    )}
                  </div>
                </div>

                <div className="">
                  <div className={`d-flex  ${sideMenu ? "bt-mob" : "bt-30"} `}>
                    <CommonIcon
                      fileName={sideMenu ? "SideBottomMobImg" : "SideBottomImg"}
                    />
                  </div>
                  <div
                    className={`${
                      sideMenu ? "sidebar-bottom-mob" : "sidebar-bottom"
                    } `}
                  >
                    <span className="sidebar-bottom-text">
                      {sideMenu ? "AC" : "ADMIN CENTER"}{" "}
                    </span>
                  </div>
                </div>
              </>
            ) : (
              !props.BG_LOADER &&
              !path.includes("/unauthorize") && (
                <div className={`menu-list menu-overflow`}>
                  <div
                    title={sideMenu ? "Home" : ""}
                    className={`${sideMenu === true ? "pt-p8 pb-p8" : " "}  ${
                      path.includes("/homepage")
                        ? sideMenu === true
                          ? "sidebar-active-mob"
                          : " sidebar-active pl-20"
                        : sideMenu === true
                        ? "sidebar-mob"
                        : "pl-20 sidebar"
                    } d-flex cursor-pointer`}
                    onClick={() => routeNavigation("/homepage")}
                  >
                    {path.includes("/homepage") ? (
                      <CommonIcon fileName={"home"} />
                    ) : (
                      <CommonIcon fileName={"home"} />
                    )}
                    {sideMenu === false && (
                      <div
                        className={`${
                          path.includes("/homepage") ? "fw-bold" : ""
                        }
                       pl-24 pr-20 text-overflow app-label d-flex`}
                      >
                        Home
                      </div>
                    )}
                  </div>
                  <div
                    title={sideMenu ? "Profile" : ""}
                    className={`${sideMenu === true ? "pt-p8 pb-p8" : " "}  ${
                      path.includes("/profile")
                        ? sideMenu === true
                          ? "sidebar-active-mob"
                          : " sidebar-active pl-20"
                        : sideMenu === true
                        ? "sidebar-mob"
                        : "pl-20 sidebar"
                    } d-flex cursor-pointer`}
                    onClick={() => routeNavigation("/profile")}
                  >
                    {path.includes("/profile") ? (
                      <CommonIcon fileName={"PersonActive"} />
                    ) : (
                      <CommonIcon fileName={"Person"} />
                    )}
                    {sideMenu === false && (
                      <div
                        className={`${
                          path.includes("/profile") ? "fw-bold" : ""
                        }
                       pl-24 pr-20 text-overflow app-label`}
                      >
                        Profile
                      </div>
                    )}
                  </div>

                  <div className="">
                    <div
                      className={`d-flex  ${sideMenu ? "bt-mob" : "bt-30"} `}
                    >
                      <CommonIcon
                        fileName={
                          sideMenu ? "SideBottomMobImg" : "SideBottomImg"
                        }
                      />
                    </div>
                    <div
                      className={`${
                        sideMenu ? "sidebar-bottom-mob" : "sidebar-bottom"
                      } `}
                    >
                      <span className="sidebar-bottom-text">
                        {sideMenu ? "USER" : "USER CENTER"}{" "}
                      </span>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        )}

        {isMobile === true && props.ShowSideBar === true && (
          <div className="side-bar-mob" style={{ height: windowHeight - 1 }}>
            <div className="row">
              <div className="col-2 cursor-pointer" onClick={ClickMenu}>
                <span className="mobile-menu">
                  <CommonIcon fileName={"MenuMob"} />
                </span>
              </div>
              <div className="col-8 pb-10 text-center">
                <span className="headerform-mob">
                  {" "}
                  <CommonIcon fileName={"flaz_logo"} />
                </span>
              </div>
            </div>

            <div className={`row profile_det_mob `}>
              <div
                className={` col-4 profile-logo-web-mob mt-3`}
                onClick={handleClick}
              >
                {/* <CommonIcon fileName={'UserPic'} /> */}
                <span
                  className={`${
                    sideMenu ? "profile-name-short-mob" : "profile-name-short"
                  } `}
                >
                  {userData?.name ? (
                    `${userData.name.charAt(0)}${userData.name
                      .split(" ")
                      .slice(-1)[0]
                      .charAt(0)
                      .toUpperCase()}`
                  ) : (
                    <CommonIcon fileName={"PersonActive"} />
                  )}
                </span>
              </div>

              <div className="col-8 profile-info">
                <p className="profile-name">{userData?.name}</p>
                <p className="profile-designation">{userData?.jobTitle}</p>
              </div>
            </div>
            {JSON.parse(localStorage.getItem("UserInfoTAC"))?.userRole ==
            "Admin" ? (
              <>
                <div className={`mobmenu-list menu-overflow`}>
                  {!isSSOTAC && (
                    <>
                      <div
                        className={`${
                          sideMenu === true ? "pt-p8 pb-p8" : " "
                        }  ${
                          path.includes("/users")
                            ? "sidebar-active-web-mob"
                            : "sidebar-web-mob"
                        } d-flex cursor-pointer`}
                        onClick={() => {
                          routeNavigation("/users");
                          ClickMenu();
                        }}
                        title="Users"
                      >
                        {path.includes("/users") ? (
                          <CommonIcon fileName={"BusinessCenterActive"} />
                        ) : (
                          <CommonIcon fileName={"BusinessCenter"} />
                        )}

                        <div
                          className={`${
                            path.includes("/users") ? "fw-bold" : ""
                          } pl-20 pr-20 text-overflow app-label`}
                        >
                          Users
                        </div>
                      </div>
                      {/* <div
                    className={`${sideMenu === true ? "pt-p8 pb-p8" : " "}  ${
                      path.includes("/groups")
                        ? "sidebar-active-web-mob"
                        : "sidebar-web-mob"
                    } d-flex cursor-pointer`}
                    onClick={() => {
                      routeNavigation("/groups");
                      ClickMenu();
                    }}
                    title="Groups"
                  >
                    {path.includes("/groups") ? (
                      <CommonIcon fileName={"Groups"} />
                    ) : (
                      <CommonIcon fileName={"Groups"} />
                    )}

                    <div
                      className={`${
                        path.includes("/groups") ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Groups
                    </div>
                  </div> */}

                      <div
                        className={`${
                          sideMenu === true ? "pt-p8 pb-p8" : " "
                        }  ${
                          path.includes("/teams")
                            ? "sidebar-active-web-mob"
                            : "sidebar-web-mob"
                        } d-flex cursor-pointer`}
                        onClick={() => {
                          routeNavigation("/teams");
                          ClickMenu();
                        }}
                        title="Teams"
                      >
                        {path.includes("/teams") ? (
                          <CommonIcon fileName={"teamsActive"} />
                        ) : (
                          <CommonIcon fileName={"teams"} />
                        )}

                        <div
                          className={`${
                            path.includes("/teams") ? "fw-bold" : ""
                          } pl-20 pr-20 text-overflow app-label`}
                        >
                          Teams
                        </div>
                      </div>
                    </>
                  )}

                  <div
                    className={`${sideMenu === true ? "pt-p8 pb-p8" : " "}  ${
                      path.includes("/applications")
                        ? "sidebar-active-web-mob"
                        : "sidebar-web-mob"
                    } d-flex cursor-pointer`}
                    onClick={() => {
                      routeNavigation("/applications");
                      ClickMenu();
                    }}
                    title="Products"
                  >
                    {path.includes("/applications") ? (
                      <CommonIcon fileName={"JobApplicationSideLogoActive"} />
                    ) : (
                      <CommonIcon fileName={"JobApplicationSideLogo"} />
                    )}

                    <div
                      className={`${
                        path.includes("/applications") ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Products
                    </div>
                  </div>
                  <div
                    className={`${sideMenu === true ? "pt-p8 pb-p8" : " "}  ${
                      path.includes("/subscription")
                        ? "sidebar-active-web-mob"
                        : "sidebar-web-mob"
                    } d-flex cursor-pointer`}
                    onClick={() => {
                      routeNavigation("/subscription");
                      ClickMenu();
                    }}
                    title="Subscription"
                  >
                    {path.includes("/subscription") ? (
                      <CommonIcon fileName={"subscription"} />
                    ) : (
                      <CommonIcon fileName={"subscription"} />
                    )}

                    <div
                      className={`${
                        path.includes("/subscription") ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Subscription
                    </div>
                  </div>
                  <div
                    className={`${sideMenu === true ? "pt-p8 pb-p8" : " "}  ${
                      path.includes("/billpayments")
                        ? "sidebar-active-web-mob"
                        : "sidebar-web-mob"
                    } d-flex cursor-pointer`}
                    onClick={() => {
                      routeNavigation("/billpayments");
                      ClickMenu();
                    }}
                    title="Bills and Payments"
                  >
                    {path.includes("/billpayments") ? (
                      <CommonIcon fileName={"bill"} />
                    ) : (
                      <CommonIcon fileName={"billnotselect"} />
                    )}

                    <div
                      className={`${
                        path.includes("/billpayments") ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Bills and Payments
                    </div>
                  </div>
                  <div
                    className={`${sideMenu === true ? "pt-p8 pb-p8" : " "}  ${
                      path.includes("/settings")
                        ? "sidebar-active-web-mob"
                        : "sidebar-web-mob"
                    } d-flex cursor-pointer`}
                    onClick={() => {
                      routeNavigation("/settings");
                      ClickMenu();
                    }}
                    title="Settings"
                  >
                    {path.includes("/settings") ? (
                      <CommonIcon fileName={"Settings"} />
                    ) : (
                      <CommonIcon fileName={"Settings"} />
                    )}

                    <div
                      className={`${
                        path.includes("/settings") ? "fw-bold" : ""
                      } pl-20 pr-20 text-overflow app-label`}
                    >
                      Settings
                    </div>
                  </div>

                  {/* <div className={`pt-p8 pb-p8 ${(path !== "/job-opening" && path !== "/job_applications" && path !== "/candidates" && path=="settings") ? 'sidebar-active-web-mob' : 'sidebar-web-mob'} d-flex cursor-pointer`}
                    onClick={() => routeNavigation("/settings")}>
                    {(path !== "/job-opening" && path !== "/job_applications" && path !== "/candidates") ? <CommonIcon fileName={'Settings'} /> : <CommonIcon fileName={'Settings'} />}
                    <div className={`${(path !== "/job-opening" && path !== "/job_applications" && path !== "/candidates") ? "fw-bold" : ""} pl-24 pr-20 text-overflow app-label`}>Settings</div>
                    <div className='text-end w-100 text-light' onClick={() => setIsSettings(!isSettings)}>{!isSettings ? <KeyboardArrowRight /> : <KeyboardArrowDown />}</div>
                  </div> */}
                  {/* <div className={`${!isSettings && `d-none`}`}>
                    <div className={`mt-2 pt-p8 pb-p8 ${path === "/company" ? 'subsidebar-active-web-mob' : 'subsidebar-web-mob'} d-flex cursor-pointer`}
                      onClick={() => routeNavigation("/company")}>
                      {path === "/company" ? <CommonIcon fileName={'Company'} /> : <CommonIcon fileName={'Company'} />}
                      <div className={`${path === "/company" ? "fw-bold" : ""} pl-24 pr-20 text-overflow app-label`}>Company</div>
                    </div>

                    <div className={`mt-2 pt-p8 pb-p8 ${path === "/language" ? 'subsidebar-active-web-mob' : 'subsidebar-web-mob'} d-flex cursor-pointer`}
                      onClick={() => routeNavigation("/language")}>
                      {path === "/language" ? <CommonIcon fileName={'Language'} /> : <CommonIcon fileName={'Language'} />}
                      <div className={`${path === "/language" ? "fw-bold" : ""} pl-24 pr-20 text-overflow app-label`}>UserLanguage</div>
                    </div>

                    <div className={`mt-2 pt-p8 pb-p8 ${path === "/language-level" ? 'subsidebar-active-web-mob' : 'subsidebar-web-mob'} d-flex cursor-pointer`}
                      onClick={() => routeNavigation("/language-level")}>
                      {path === "/language-level" ? <CommonIcon fileName={'LanguageLevel'} /> : <CommonIcon fileName={'LanguageLevel'} />}
                      <div className={`${path === "/language-level" ? "fw-bold" : ""} pl-24 pr-20 text-overflow app-label`}>Language Level</div>
                    </div>

                    <div className={`mt-2 pt-p8 pb-p8 ${path === "/lookup" ? 'subsidebar-active-web-mob' : 'subsidebar-web-mob'} d-flex cursor-pointer`}
                      onClick={() => routeNavigation("/lookup")}>
                      {path === "/lookup" ? <CommonIcon fileName={'Lookup'} /> : <CommonIcon fileName={'Lookup'} />}
                      <div className={`${path === "/lookup" ? "fw-bold" : ""} pl-24 pr-20 text-overflow app-label`}>Lookup</div>
                    </div>

                    <div className={`mt-2 pt-p8 pb-p8 ${path === "/client" ? 'subsidebar-active-web-mob' : 'subsidebar-web-mob'} d-flex cursor-pointer`}
                      onClick={() => routeNavigation("/client")}>
                      {path === "/client" ? <CommonIcon fileName={'Client'} /> : <CommonIcon fileName={'Client'} />}
                      <div className={`${path === "/client" ? "fw-bold" : ""} pl-24 pr-20 text-overflow app-label`}>Client</div>
                    </div>
                    <div className={`mt-2 pt-p8 pb-p8 ${path === "/checkList" ? 'subsidebar-active-web-mob' : 'subsidebar-web-mob'} d-flex cursor-pointer`}
                      onClick={() => routeNavigation("/checkList")}>
                      {path === "/checkList" ? <CommonIcon fileName={'Recruiter'} /> : <CommonIcon fileName={'Recruiter'} />}
                      <div className={`${path === "/checkList" ? "fw-bold" : ""} pl-24 pr-20 text-overflow app-label`}>Check List</div>
                    </div>
                  </div> */}
                </div>

                <div className={`d-flex bt-mobile`}>
                  <CommonIcon fileName={"SideBottomImg"} />
                </div>
                <div className="sidebar-bottom-mobile">
                  <span className="sidebar-bottom-text">ADMIN CENTER</span>
                </div>
              </>
            ) : (
              <>
                <div className={`mobmenu-list menu-overflow`}>
                  <div
                    className={`${sideMenu === true ? "pt-p8 pb-p8" : " "}  ${
                      path.includes("/homepage")
                        ? "sidebar-active-web-mob"
                        : "sidebar-web-mob"
                    } d-flex cursor-pointer`}
                    onClick={() => {
                      routeNavigation("/homepage");
                      ClickMenu();
                    }}
                    title="homepage"
                  >
                    {path.includes("/homepage") ? (
                      <CommonIcon fileName={"home"} />
                    ) : (
                      <CommonIcon fileName={"home"} />
                    )}

                    <div
                      className={`${
                        path.includes("/homepage") ? "fw-bold" : ""
                      }   pl-20 pr-20 text-overflow app-label`}
                    >
                      Home
                    </div>
                  </div>
                  <div
                    className={`${sideMenu === true ? "pt-p8 pb-p8" : " "}  ${
                      path.includes("/profile")
                        ? "sidebar-active-web-mob"
                        : "sidebar-web-mob"
                    } d-flex cursor-pointer`}
                    onClick={() => {
                      routeNavigation("/profile");
                      ClickMenu();
                    }}
                    title="Profile"
                  >
                    {path.includes("/profile") ? (
                      <CommonIcon fileName={"PersonActive"} />
                    ) : (
                      <CommonIcon fileName={"Person"} />
                    )}

                    <div
                      className={`${
                        path.includes("/homepage") ? "fw-bold" : ""
                      }  pl-20 pr-20 text-overflow app-label`}
                    >
                      Profile
                    </div>
                  </div>
                  {/* <div className={`pt-p8 pb-p8 ${path === "/profile" ? 'sidebar-active-web-mob' : 'sidebar-web-mob'} d-flex cursor-pointer`}
                    onClick={() => routeNavigation("/profile")}>
                    {path === "/profile" ? <CommonIcon fileName={'PersonActive'} /> : <CommonIcon fileName={'Person'} />}
                    <div className={`${path === "/profile" ? "fw-bold" : ""} pl-24 pr-20 text-overflow app-label`}>Profile</div>
                  </div> */}
                </div>

                <div className={`d-flex bt-mobile`}>
                  <CommonIcon fileName={"SideBottomImg"} />
                </div>
                <div className="sidebar-bottom-mobile">
                  <span className="sidebar-bottom-text">USER</span>
                </div>
              </>
            )}
          </div>
        )}
        {/* ********* logout modal popup *********** */}
        <div
          className={`modal modal-style viewbar-overlay  ${
            opendialog ? "show" : ""
          }`}
          id="Additionform"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ display: opendialog ? "block" : "none" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-lg bg-white rounded">
              <div className="modal-body text-center">
                <CommonIcon fileName={"logouticon"} />
                <br />
                <span>{"Are you sure you want to log out?"}</span>
              </div>
              <div className="modal-footer justify-content-center">
                <Button
                  className="btn-no px-4"
                  variant="primary"
                  onClick={() => noAction()}
                >
                  No
                </Button>{" "}
                <Button
                  className="btn-action px-4"
                  variant="primary"
                  onClick={() => yesAction()}
                >
                  Yes
                </Button>{" "}
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    ShowSideBar: state.SideBarReducer.ShowSideBar,
    menuToggle: state.SideBarReducer.menuToggle,
    isLogin: state.loginReducer.isLogin,
    BG_LOADER: state.userReducer.BG_LOADER,
    BG_HOME_LOADER: state.userReducer.BG_HOME_LOADER,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleMenu: () => dispatch(toggleMenu()) || false,
    sideMenu: () => dispatch(sideMenu()) || false,
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
